function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient",
  cx: 486.37,
  cy: 529.62,
  r: 3063.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1199da",
  stopOpacity: 0.95
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#2b68b1",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#493083",
  stopOpacity: 0.99
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#551b71"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-3",
  cx: 483.63,
  cy: 539.19,
  r: 2556.84,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-4",
  cx: 492.79,
  cy: 533.52,
  r: 2819.48,
  xlinkHref: "#radial-gradient"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "radial-gradient-5",
  cx: 495.99,
  cy: 540.79,
  r: 2890.97,
  xlinkHref: "#radial-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M429.57,626.37c-8.39,0-21.3,6.8-28.85,15.18L314.15,737.7h60.73L475.12,626.37Z",
  fill: "url(#radial-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M520.67,626.37c-4.19,0-10.66,3.4-14.43,7.6L412.83,737.7h45.55L558.62,626.37Z",
  fill: "url(#radial-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M475.12,588.42H429.57c-8.38,0-21.3-6.8-28.85-15.19L0,128.18V60.75Z",
  fill: "url(#radial-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M558.63,588.42h-38c-4.2,0-10.66-3.4-14.43-7.59L0,18.59V0H28.81Z",
  fill: "url(#radial-gradient-4)"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "643.34 606.63 525.32 737.7 494.95 737.7 612.98 606.63 612.97 606.63 66.76 0 97.13 0 643.34 606.63",
  fill: "url(#radial-gradient-5)"
}));

function SvgDecoration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 643.34 737.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.02bc794df5f2e2cb3ca6a4d94aa61e16.svg";
export { ForwardRef as ReactComponent };